import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./CookieConsentModal.css";

const CONSENT_KEY = "wayo_cookie_consent";

export default function CookieConsentModal({ onConsentChange }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const savedConsent = window.localStorage.getItem(CONSENT_KEY);
    setIsVisible(savedConsent !== "accepted" && savedConsent !== "rejected");
  }, []);

  const saveConsent = (value) => {
    window.localStorage.setItem(CONSENT_KEY, value);
    setIsVisible(false);
    onConsentChange?.(value);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-modal-overlay" role="presentation">
      <section
        className="cookie-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cookie-modal-title"
      >
        <div className="cookie-modal-content">
          <p className="cookie-modal-eyebrow">Privacidad</p>
          <h2 id="cookie-modal-title">Usamos cookies</h2>
          <p>
            Usamos cookies esenciales y, si aceptas, cookies de analisis para
            mejorar Wayo.
          </p>
          <Link to="/cookies" className="cookie-modal-link">
            Leer politica de cookies
          </Link>
        </div>
        <div className="cookie-modal-actions">
          <button
            type="button"
            className="cookie-modal-button cookie-modal-button-secondary"
            onClick={() => saveConsent("rejected")}
          >
            Rechazar
          </button>
          <button
            type="button"
            className="cookie-modal-button cookie-modal-button-primary"
            onClick={() => saveConsent("accepted")}
          >
            Aceptar
          </button>
        </div>
      </section>
    </div>
  );
}
